module.exports = __webpack_public_path__ + "media/images/logo/qlean-workes-brand-878ba2d71d3a4c2f0ea226efefdf8975.svg";